module.exports = new __parcel__URL__("carouselHubElementThumbnail.18a104a0.svg").toString();